export const promote = (config) => ({
    ...config,
    requestTimeoutSeconds: 30
});
//# sourceMappingURL=webhook-webhook-6-to-7.js.map